import React from 'react';
import nextLazyLoad from 'next/dynamic';

type OptionsParam = {
  fallback?: Function | JSX.Element;
  ssr?: boolean;
};

const LazyLoad = (fn, options: OptionsParam = {}) => {
  let newOptions;
  if (options?.fallback) {
    newOptions = {
      loading: React.isValidElement(options?.fallback)
        ? () => options?.fallback
        : options?.fallback,
    };
  }

  return nextLazyLoad(fn, { ...(newOptions || options) });
};

export default LazyLoad;
